import styled from 'styled-components'

import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { sanitizePrice } from 'utils/math'

const Discount = styled.span<TSFixMe>`
  color: #b71c1c;
`

export const TotalWithDiscount = ({ total, discount, currency }: TSFixMe): TSFixMe => {
  return (
    <div>
      <FormattedPrice value={sanitizePrice(total)} currency={currency} />

      {discount > 0 && (
        <Discount>
          &nbsp;(-
          <FormattedPrice value={discount} currency={currency} />)
        </Discount>
      )}
    </div>
  )
}
